import { render, staticRenderFns } from "./inputCustomRegister.vue?vue&type=template&id=64bc6426&scoped=true&"
import script from "./inputCustomRegister.vue?vue&type=script&lang=js&"
export * from "./inputCustomRegister.vue?vue&type=script&lang=js&"
import style0 from "./inputCustomRegister.vue?vue&type=style&index=0&id=64bc6426&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bc6426",
  null
  
)

export default component.exports